import React from "react"
import { Button, Modal } from "react-bootstrap"

import { getStatusDetails } from "./LabelingCompleteLabel"
import { isLTPM } from "../../../../../components/shared_components_registration"

export default function CompleteRunEventLabelingModal({
  show,
  onHide,
  exportBaseName = "",
  run = {},
  onConfirm,
}) {
  if (isLTPM) {
    return <></>
  }
  const { labelingComplete = false, labelingCompleteOn, labelingCompleteBy } = run
  const details = getStatusDetails(labelingCompleteOn, labelingCompleteBy)
  return (
    <Modal size={"lg"} show={show} onHide={onHide} backdrop={"static"}>
      <Modal.Header closeButton>
        <Modal.Title>{`Toggle Run Labeling Status: ${exportBaseName}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          className={"solid-grey-border"}
          style={{ borderRadius: "5px", padding: "30px", backgroundColor: "var(--lanzalake-grey-light-2)" }}
        >
          {labelingComplete ? (
            <div>
              This run is currently marked with a labeling status of 'complete'. Would you like to mark this
              run's labeling status as 'incomplete' instead? This change would indicate that this run is not
              fully labeled at this point and requires further edits and additions to be considered as such.
            </div>
          ) : (
            <div>
              This run is currently marked with a labeling status of 'incomplete'. Is this run now completely
              labeled? A run is considered completely labeled if the entire run duration has labels applied
              where appropriate. Any unlabeled portion can considered intentionally unlabeled.
            </div>
          )}
          {details && <div style={{ marginTop: "10px" }}>{details}</div>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Confirm Status Change
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
